import { Injectable } from '@angular/core';
import { BullhornDataSourceApiService } from 'datasource-service-lib';
import { IDocumentType } from 'document-type-picker-lib';
import { BLANK_TYPE, FilterLabel, IDocumentTypeService } from 'document-type-picker-lib';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export interface IDocTypeCacheEntry {
  key: string;
  type: IDocumentType[];
}

@Injectable({ providedIn: 'root' })
export class BullhornDocumentTypeService implements IDocumentTypeService {
  // the settings values will not change very often per corp
  private cache: IDocTypeCacheEntry[] = [];

  constructor(private apiService: BullhornDataSourceApiService) {}

  getDocumentTypeLabel(): string {
    return 'file';
  }

  getDocumentTypes(entityType: string, filterLabel?: FilterLabel): Observable<IDocumentType[]> {
    let cacheValue: IDocTypeCacheEntry | undefined;
    if (filterLabel === FilterLabel.NOTE) {
      const key = 'commentActionList';
      cacheValue = this.checkCache(key);
      return cacheValue ? of(cacheValue.type) : this.getDocumentTypeSettings(key, false);
    }
    const fileTypeList: string = entityType === 'ClientCorporation' ? 'clientCorporationFileTypeList' : 'fileTypeList';
    cacheValue = this.checkCache(fileTypeList);
    return cacheValue ? of(cacheValue.type) : this.getDocumentTypeSettings(fileTypeList);
  }

  getRecordTerm(): string {
    return 'entity';
  }

  private getDocumentTypeSettings(key: string, includeBlankType = true): Observable<IDocumentType[]> {
    return this.apiService.settings(key).pipe(
      map((response) => {
        const mappedResponse = response[key].map((ft: any) => ({ id: ft, label: ft }));
        if (includeBlankType) {
          mappedResponse.push(BLANK_TYPE);
        }
        this.cache.push({ key, type: mappedResponse });
        return mappedResponse;
      }),
    );
  }

  private checkCache(key: string): IDocTypeCacheEntry | undefined {
    return this.cache.find((c) => c.key === key);
  }
}
